import { render } from "./portraits-wrong-book.vue?vue&type=template&id=13ba4edc&scoped=true"
import script from "./portraits-wrong-book.vue?vue&type=script&lang=js"
export * from "./portraits-wrong-book.vue?vue&type=script&lang=js"

import "./portraits-wrong-book.vue?vue&type=style&index=0&id=13ba4edc&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ba4edc"]])

export default __exports__